import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card seq-card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body py-6" }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label d-block mb-2" }, "Date Range", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeaderboardBanner = _resolveComponent("LeaderboardBanner")
  const _component_SeqDateRangePicker = _resolveComponent("SeqDateRangePicker")
  const _component_LeaderboardList = _resolveComponent("LeaderboardList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_LeaderboardBanner, {
        metric: _ctx.metric,
        class: "mb-6"
      }, null, 8, ["metric"]),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_SeqDateRangePicker, { onChange: _ctx.onDateRangeChange }, null, 8, ["onChange"])
      ]),
      _createVNode(_component_LeaderboardList, {
        rows: _ctx.rows,
        metric: _ctx.metric,
        loading: _ctx.loading,
        error: _ctx.error,
        "currency-symbol": _ctx.currencySymbol
      }, null, 8, ["rows", "metric", "loading", "error", "currency-symbol"])
    ])
  ]))
}